// Shared sound player using Web Audio API.
// Loads MP3 files from /sounds/ and plays them via AudioBuffer so we can
// trim the success clip to the first SUCCESS_DURATION seconds.

const SUCCESS_DURATION = 0.88; // seconds — cut after the initial chime hit
const ERROR_DURATION   = 0.80; // seconds — cut after the initial wrong-buzzer hit

let ctx = null;
const buffers = {};

function getCtx() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    return ctx;
}

async function loadBuffer(name) {
    if (buffers[name]) return buffers[name];
    try {
        const res = await fetch(`/sounds/${name}.mp3`);
        const arrayBuf = await res.arrayBuffer();
        const audioBuf = await getCtx().decodeAudioData(arrayBuf);
        buffers[name] = audioBuf;
        return audioBuf;
    } catch {
        return null;
    }
}

// Preload both files early so playback is instant
export function preloadSounds() {
    loadBuffer('success');
    loadBuffer('wrong');
    loadBuffer('order_finished');
}

// iOS Safari requires AudioContext.resume() to be called SYNCHRONOUSLY inside
// the user-gesture handler. The first `await` in a player fn detaches us from
// the gesture, so resume after that is a no-op on iOS. We call this from the
// synchronous head of every player fn, before any await.
function primeCtx() {
    try {
        const c = getCtx();
        if (c.state === 'suspended') c.resume();
    } catch { /* ignore */ }
}

function playBuffer(buf, duration) {
    if (!buf) return;
    try {
        const c = getCtx();
        if (c.state === 'suspended') c.resume();
        const src = c.createBufferSource();
        src.buffer = buf;
        src.connect(c.destination);
        src.start(0, 0, duration ?? buf.duration);
    } catch { /* not critical */ }
}

export async function playSuccess() {
    primeCtx();
    const buf = await loadBuffer('success');
    playBuffer(buf, SUCCESS_DURATION);
}

export async function playError() {
    primeCtx();
    const buf = await loadBuffer('wrong');
    playBuffer(buf, ERROR_DURATION);
}

export async function playOrderFinished() {
    primeCtx();
    const buf = await loadBuffer('order_finished');
    playBuffer(buf);
}
